import gql from 'graphql-tag';

export const AchievementLevelDetails = gql`
  fragment AchievementLevelDetails on AchievementLevel {
    id
    goal
    name
    description
    rewards {
      id
      type
      amount
      name
    }
    achievement {
      id
    }
  }
`;

export const AchievementDetails = gql`
  fragment AchievementDetails on Achievement {
    id
    action
    name
    description
    levels {
      ...AchievementLevelDetails
    }
  }
  ${AchievementLevelDetails}
`;
